import { takeEvery, put, call, fork, all } from "redux-saga/effects";
import {
  apiError,
  getStoreCompaniesSuccess,
  getStoreEmployeesSuccess,
  getStorePartsSuccess,
  getStoreGradesSuccess,
  getStoreGroupsSuccess,
  getStoreCareCompaniesSuccess,
  getUnreadNotificationCountSuccess,
  getTaxpayerListSuccess,
} from "./actions";
import { GET_COMPANIES, GET_EMPLOYEES, GET_PARTS, GET_TAXPAYER_LIST, GET_UNREAD_NOTIFICATION_COUNT } from "./actionTypes";
import { getCEOs, getEmployee, getEmployees as _getEmployees, getFinanceManagers } from "../../apis/employee/employee";
import { getParts as _getParts } from "../../apis/companies/parts";
import { getMyCompanies } from "../../apis/companies/companies";
import { getGradeList } from "../../apis/companies/grade";
import { getGroupsList } from "../../apis/companies/group";
import { getCompanyTokenInfo } from "../../apis/auth";
import { getCareCompanies } from "../../apis/admin/companies";
import { getTaxpayerList as _getTaxpayerList } from "../../apis/tax-portal/taxpayer";
import { getUnreadNotifications } from "../../apis/notification";

function* getStoreEmployeeList({ payload: employee }) {
  try {
    const companyInfo = getCompanyTokenInfo();
    // employee 정보가 없는 경우 
    if (!employee) {
      employee = yield call(getEmployee, companyInfo.employeeIdx);
    }
    const myRoleRange = (employee && employee.roleRange) || 'ALL';
    const employees = yield call(_getEmployees);
    const myRoleEmployees = yield call(_getEmployees, { roleRange: myRoleRange });

    const ceos = yield call(getCEOs);
    const financeManagers = yield call(getFinanceManagers);
    const managerEmployees = [];
    if (companyInfo.type > 1) {
      managerEmployees.push(...yield call(_getEmployees, { roleRange: myRoleRange, searchCompanyIdx: companyInfo.managerCompanyIdx }));
    }

    yield put(getStoreEmployeesSuccess({
      employees,
      myRoleEmployees,
      myRoleEmployeesIdx: myRoleEmployees.map(e => e.idx),
      ceos,
      financeManagers,
      managerEmployees,
    }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getStorePartList({ payload: employee }) {
  try {
    const companyInfo = getCompanyTokenInfo();
    if (!employee) {
      employee = yield call(getEmployee, companyInfo.employeeIdx);
    }
    const myRoleRange = (employee && employee.roleRange) || 'ALL';
    const parts = yield call(_getParts);
    const myRoleParts = yield call(_getParts, { roleRange: myRoleRange });
    const managerParts = [];
    if (companyInfo.type > 1) {
      managerParts.push(...yield call(_getParts, { roleRange: 'ALL', isTax: true }));
    }

    yield put(getStorePartsSuccess({
      parts,
      myRoleParts,
      myRolePartsIdx: myRoleParts.map(e => e.idx),
      managerParts,
    }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getStoreCompanyList({ payload: params }) {
  try {
    const companyInfo = getCompanyTokenInfo();
    const response = yield call(getMyCompanies);
    const companies = response.data.companies;
    yield put(getStoreCompaniesSuccess(companies));
    if (companyInfo.type !== 1) {
      const careCompanies = yield call(getCareCompanies, companyInfo.managerCompanyIdx, companyInfo.type);
      const managerCompany = companies.find(c => c.companyIdx === companyInfo.managerCompanyIdx);

      // debugger
      yield put(getStoreCareCompaniesSuccess([managerCompany, ...careCompanies.data.companies]));
    } else {
      yield put(getStoreCareCompaniesSuccess([]));
    }

  } catch (error) {
    yield put(apiError(error));
  }
}

function* getStoreGradeList({ payload: params }) {
  try {
    const companyInfo = getCompanyTokenInfo();

    const managerGrades = [];
    const grades = yield call(getGradeList);
    if (companyInfo.type > 1) {
      const data = yield call(getGradeList, { isTax: true });
      managerGrades.push(...data?.data?.grades || []);
    }
    yield put(getStoreGradesSuccess({
      grades: grades.data.grades,
      managerGrades,
    }));
  } catch (error) {
    yield put(apiError(error));
  }
}


function* getStoreGroupList({ payload: params }) {
  try {
    const companyInfo = getCompanyTokenInfo();
    const groups = yield call(getGroupsList);
    const managerGroups = [];

    if (companyInfo.type > 1) {
      const data = yield call(getGroupsList, { isTax: true });
      managerGroups.push(...data?.data?.groups || []);
    }
    yield put(getStoreGroupsSuccess({
      groups: groups.data.groups,
      managerGroups
    }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getStoreUnreadNotificationCount({ payload: params }) {
  try {
    const response = yield call(getUnreadNotifications);
    yield put(getUnreadNotificationCountSuccess(response.data.total));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getTaxpayerList({ payload: employee }) {
  try {
    // employee 정보가 없는 경우 
    const response = yield call(_getTaxpayerList);
    yield put(getTaxpayerListSuccess(response.rows));
  } catch (error) {
    yield put(apiError(error));
  }
}


function* watchGetEmployeeList() {
  yield takeEvery(GET_EMPLOYEES, getStoreEmployeeList);
}

function* watchGetPartList() {
  yield takeEvery(GET_PARTS, getStorePartList);
}

function* watchGetCompanyList() {
  yield takeEvery(GET_COMPANIES, getStoreCompanyList);
}

function* watchGetGradeList() {
  yield takeEvery(GET_COMPANIES, getStoreGradeList);
}

function* watchGetGroupList() {
  yield takeEvery(GET_COMPANIES, getStoreGroupList);
}
function* watchGetUnreadNotificationCount() {
  yield takeEvery(GET_UNREAD_NOTIFICATION_COUNT, getStoreUnreadNotificationCount);
}

function* watchGetTaxpayerList() {
  yield takeEvery(GET_TAXPAYER_LIST, getTaxpayerList);
}

function* DataSaga() {
  yield all([
    fork(watchGetEmployeeList),
    fork(watchGetPartList),
    fork(watchGetCompanyList),
    fork(watchGetGradeList),
    fork(watchGetGroupList),
    fork(watchGetUnreadNotificationCount),
    fork(watchGetTaxpayerList)
  ]);
}



export default DataSaga;
